var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorCategory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H3.5C4.5 5 5 4.5 5 3.5V2.5C5 1.5 4.5 1 3.5 1H2.5C1.5 1 1 1.5 1 2.5V3.5C1 4.5 1.5 5 2.5 5Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5H9.5C10.5 5 11 4.5 11 3.5V2.5C11 1.5 10.5 1 9.5 1H8.5C7.5 1 7 1.5 7 2.5V3.5C7 4.5 7.5 5 8.5 5Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11H9.5C10.5 11 11 10.5 11 9.5V8.5C11 7.5 10.5 7 9.5 7H8.5C7.5 7 7 7.5 7 8.5V9.5C7 10.5 7.5 11 8.5 11Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 11H3.5C4.5 11 5 10.5 5 9.5V8.5C5 7.5 4.5 7 3.5 7H2.5C1.5 7 1 7.5 1 8.5V9.5C1 10.5 1.5 11 2.5 11Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCategory);
export default __webpack_public_path__ + "static/media/color_category.899d00e5a28b87b54656c3db26ea6f19.svg";
export { ForwardRef as ReactComponent };